import { LineString } from 'ol/geom';
import GeometryCollection from 'ol/geom/GeometryCollection';
const usageTypes = {
  forward: 0,
  backward: 1,
  twoWay: 2,
  boundaryTwoWay: 3,
  boundaryNonNavigable: 4
};

const getRotation = (from, to) => {
  const dx = to[0] - from[0];
  const dy = to[1] - from[1];
  return Math.atan2(dy, dx);
};

export default (({
  size
}) => feature => {
  const geometry = feature.getGeometry();
  const usage = +feature.get('Usage');
  const coordinates = geometry.getCoordinates();
  const lineLength = geometry.getLength();
  let sizeFactor = size;

  if (sizeFactor > lineLength / 2.5) {
    sizeFactor = lineLength * 0.4;
  }

  const from = coordinates[0];
  const to = coordinates[1];
  let arrPosition = [(from[0] + to[0]) / 2, (from[1] + to[1]) / 2];

  if (usage === usageTypes.forward || usage === usageTypes.backward) {
    let rotation = getRotation(from, arrPosition);
    const arrSide1 = new LineString([arrPosition, [arrPosition[0] + sizeFactor, arrPosition[1] - sizeFactor * .3]]);
    const arrSide2 = new LineString([arrPosition, [arrPosition[0] + sizeFactor, arrPosition[1] + sizeFactor * .3]]);

    if (usage === usageTypes.forward) {
      rotation -= Math.PI;
    }

    arrSide1.rotate(rotation, arrPosition);
    arrSide2.rotate(rotation, arrPosition);
    return new GeometryCollection([geometry, arrSide1, arrSide2]);
  }

  return geometry;
});